/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdatePreferredProviderErrorResponse,
  UpdatePreferredProviderRequest,
  UpdatePreferredProviderResponse,
} from './api.schemas';

import { api } from '../util/http';

export const updateEncountersPreferencesProvider = (
  encounterId: number,
  updatePreferredProviderRequest: UpdatePreferredProviderRequest,
) => {
  return api<UpdatePreferredProviderResponse>({
    url: `/api/encounters/${encounterId}/preferences/provider`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updatePreferredProviderRequest,
  });
};

export const getUpdateEncountersPreferencesProviderMutationOptions = <
  TError = UpdatePreferredProviderErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEncountersPreferencesProvider>>,
    TError,
    { encounterId: number; data: UpdatePreferredProviderRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEncountersPreferencesProvider>>,
  TError,
  { encounterId: number; data: UpdatePreferredProviderRequest },
  TContext
> => {
  const mutationKey = ['updateEncountersPreferencesProvider'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEncountersPreferencesProvider>>,
    { encounterId: number; data: UpdatePreferredProviderRequest }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return updateEncountersPreferencesProvider(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEncountersPreferencesProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEncountersPreferencesProvider>>
>;
export type UpdateEncountersPreferencesProviderMutationBody = UpdatePreferredProviderRequest;
export type UpdateEncountersPreferencesProviderMutationError = UpdatePreferredProviderErrorResponse;

export const useUpdateEncountersPreferencesProvider = <
  TError = UpdatePreferredProviderErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEncountersPreferencesProvider>>,
      TError,
      { encounterId: number; data: UpdatePreferredProviderRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEncountersPreferencesProvider>>,
  TError,
  { encounterId: number; data: UpdatePreferredProviderRequest },
  TContext
> => {
  const mutationOptions = getUpdateEncountersPreferencesProviderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
